import { QueryExecution } from '../../../xdr/liveSearch/types';

export interface SmartViewItem {
  id: string;
  content: string;
  name: string;
  originalName: string | null;
  lastExecution: QueryExecution | null;
  hasResults: boolean;
  companyId: string | null;
  isRecent: boolean;
  isReadOnly: boolean;
  isEdited: boolean | null;
  targetFilters: LiveSearchFilters;
}

export interface LiveSearchFilters {
  companyId: string;
  companyName: string;
  operatingSystems: Array<string | number>;
  endpoints: Array<string | number>;
  tags: Array<string>;
}

export interface QueryExecutionResponse {
  success: boolean;
  data: QueryExecution;
}

export interface RpcResponse {
  success: boolean;
  data?: string;
}

export const LIVE_CODE_EDITOR_OPTIONS = {
  editorOptions: {
    lineNumbers: 'on',
    lineNumbersMinChars: 3,
    overviewRulerBorder: true,
    value: ``,
    quickSuggestions: {
      strings: false,
      other: false,
      comments: false,
    },
    lineDecorationsWidth: 10,
    bracketPairColorization: {
      enabled: true,
    },
    scrollbar: {
      vertical: 'visible',
    },
  },
  languageOptions: {
    validate: true,
    autoComplete: false,
    hover: false,
    schema: {
      syntaxError: 'Syntax error',
    },
  },
};

export interface LocalState {
  queryContent: string;
  targetFilters: LiveSearchFilters;
}

export enum LIVESEARCH_ITEM_TYPES {
  RECENT = 'recent',
  SAVED = 'saved',
  FEATURED = 'featured',
}
export enum LivesearchEvents {
  SMART_VIEWS_LOADED = 'smartViewsLoaded',
}

export const ERROR_CODE_NAME_ALREADY_EXISTS = 3351;

export const SMART_VIEW_MAX_INPUT_LENGTH = 64;

export const DEFAULT_VIEW_ID = 'default_view';

export interface LivesearchLabelParts {
  timePrefix: string;
  draftPrefix: string;
  searchableLabelPart: string;
}

export interface LiveSearchPivotingObject {
  companyId: string;
  companyName: string;
  endpointIds: string[] | null;
  operatingSystems: number[] | null;
  predefinedQuery: string | null;
  presetQuery: string | null;
  presetQueryParams: Object | null;
}
